import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(10, 18),
    },
    gridContainer: {
      height: "calc(100vh - 102px)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: theme.spacing(60, 0, 135, 0),
    },
    iconWrapper: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(5),
      borderRadius: "140px",
      backgroundColor: "#EFEDF6",
      marginBottom: theme.spacing(8),
    },
    icon: {
      width: "24px",
      height: "24px",
    },
    title: {
      fontSize: "24px",
      fontWeight: 500,
      lineHeight: "29px",
      color: "#130F3A",
      marginBottom: theme.spacing(4),
    },
    subtitle: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      color: theme.gray500,
      marginBottom: theme.spacing(12),
    },
    btnSection: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: theme.spacing(12),
      marginBottom: theme.spacing(12),
    },
    sampleCsvBtn: {
      display: "flex",
      gap: theme.spacing(2.5),
    },
    tabsContainer: {
      padding: theme.spacing(5, 0),
      borderBottom: `1px solid ${theme.gray200}`,
    },
    detailsWrapper: {
      marginTop: theme.spacing(8),
      marginBottom: theme.spacing(12),
    },
    settingsContainer: {
      alignItems: "start",
      fontWeight: 500,
      flexWrap: "nowrap",
      gap: theme.spacing(12),
      margin: theme.spacing(8, 0),
    },
    gridChild: {
      background: theme.white50,
      border: `1px solid ${theme.gray200}`,
      borderRadius: 8,
      boxShadow: "0px 1px 1px rgba(154, 147, 147, 0.25)",
      display: "flex",
      flexDirection: "column",
    },
    header: {
      background: theme.gray50,
      borderRadius: "8px 8px 0 0",
      boxShadow: `0px 1px 0px ${theme.gray200}`,
      color: theme.gray800,
      padding: theme.spacing(6, 8),
      fontWeight: 500,
    },
    content: {
      boxShadow: `0px 1px 0px ${theme.gray100}`,
      display: "flex",
      fontSize: 14,
      fontWeight: 500,
      gap: theme.spacing(10),
      justifyContent: "space-between",
      padding: theme.spacing(8, 12),
    },
    left: {
      alignItems: "center",
      color: theme.gray500,
      display: "flex",
      gap: "5px",
      minWidth: "200px",
    },
    right: {
      color: theme.gray800,
      display: "flex",
      flexWrap: "wrap",
      gap: theme.spacing(6),
      textAlign: "right",
      wordBreak: "break-word",
      maxWidth: "900px",
      "& #boxElement": {
        margin: theme.spacing(0, 3),
      },
      "& > div": {
        gap: theme.spacing(2),
        justifyContent: "flex-end",
      },
    },
    criterion: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(9, 10),
    },
    ruleHeader: {
      background: theme.gray50,
      padding: theme.spacing(6, 8),
      marginTop: 1,
      gap: theme.spacing(2),
      fontSize: 14,
      fontWeight: 500,
    },
    operator: {
      marginLeft: theme.spacing(10),
      textTransform: "uppercase",
      fontSize: 14,
      fontWeight: 500,
    },
    metricsHeader: {
      paddingTop: theme.spacing(12),
      paddingLeft: theme.spacing(3),
      display: "flex",
      justifyContent: "space-between",
    },
    sectionTitle: {
      fontSize: 16,
      fontWeight: 500,
    },
    emptyState: {
      marginTop: theme.spacing(30),
    },
  }),
);
